import Icon from '../components/Icon.vue'

Icon.register({"paint-brush":{"width":512,"height":512,"paths":[{"d":"M269.9 364.6C271.3 371 272 377.6 272 384.3 272 465.5 217.8 512 137.2 512 41.5 512 0 435.1 0 347.6 10.4 354.7 46.9 384.1 58.7 384.1 65.7 384.1 71.7 380.1 74.2 373.5 97.8 311.3 140.7 297 187.1 296.1 202.7 329.9 233.2 355.7 269.9 364.6zM460.6 0C446.2 0 432.7 6.4 422.4 15.7 228.2 190 208 194.1 208 245.4 208 294.2 248.5 336 298.2 336 357.2 336 391.4 292.6 498.8 91.2 505.8 77.5 512 62.7 512 47.3 512 19.7 487.3 0 460.6 0z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/paint-brush.js